module.exports = __webpack_public_path__ + "media/images/site-section/icons/sprite-e2db6504f12379e42088edb414a87191.svg";